import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex justify-center mb-8">
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-1 shadow-2xl">
        <button
          onClick={() => setActiveTab('order')}
          className={`px-8 py-3 rounded-xl font-semibold transition-all ${
            activeTab === 'order'
              ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white shadow-lg'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          Take Orders
        </button>
        <button
          onClick={() => setActiveTab('menu')}
          className={`px-8 py-3 rounded-xl font-semibold transition-all ${
            activeTab === 'menu'
              ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          Manage Menu
        </button>
      </div>
    </div>
  );
};

export default TabNavigation; 